import { omitNilProperties } from './omitNilProperties';

export function getFilesFromFolder(
  requireModule: __WebpackModuleApi.RequireContext
) {
  const files = requireModule.keys().reduce((accumulatorFiles, fileName) => {
    const formatedFileName = fileName.replace(/(\.\/|\.[^.]*$)/g, '');

    return {
      ...accumulatorFiles,
      [formatedFileName]: requireModule(fileName).default
    };
  }, {});

  return omitNilProperties(files);
}
